<div class="pto-approval-queue-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-left">
      <div class="header-icon">
        <mat-icon>assignment_turned_in</mat-icon>
      </div>
      <div class="header-text">
        <h2>My Requests Time Off</h2>
        <p class="header-subtitle">Review and manage your time-off requests</p>
      </div>
    </div>
    <button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Metrics Bar -->
  <div class="metrics-bar">
    <div class="metric-card">
      <mat-icon>assignment</mat-icon>
      <div class="metric-content">
        <span class="metric-value">{{ totalRequests }}</span>
        <span class="metric-label">Total Requests</span>
      </div>
    </div>
    <div class="metric-card pending">
      <mat-icon>schedule</mat-icon>
      <div class="metric-content">
        <span class="metric-value">{{ pendingCount }}</span>
        <span class="metric-label">Pending</span>
      </div>
    </div>
    <div class="metric-card approved">
      <mat-icon>check_circle</mat-icon>
      <div class="metric-content">
        <span class="metric-value">{{ approvedCount }}</span>
        <span class="metric-label">Approved</span>
      </div>
    </div>
    <div class="metric-card denied">
      <mat-icon>cancel</mat-icon>
      <div class="metric-content">
        <span class="metric-value">{{ deniedCount }}</span>
        <span class="metric-label">Denied</span>
      </div>
    </div>
  </div>

  <!-- Filters Bar -->
  <div class="filters-bar">
    <div class="search-box">
      <mat-icon>search</mat-icon>
      <input type="text"
        placeholder="Search by notes..."
        [(ngModel)]="filters.searchTerm"
        (ngModelChange)="onSearchTextChange()">
      @if (filters.searchTerm) {
        <button class="clear-search" (click)="filters.searchTerm = ''; onSearchTextChange()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

    <div class="filter-group">
      <ng-select [items]="typeOptions"
        bindLabel="label"
        bindValue="value"
        [(ngModel)]="filters.type"
        (ngModelChange)="onFiltersChange()"
        [clearable]="false"
        [searchable]="false"
        class="filter-select type-filter">
        <ng-template ng-label-tmp let-item="item">
          <span class="filter-label">
            <mat-icon>category</mat-icon>
            {{ item.label }}
          </span>
        </ng-template>
      </ng-select>

      <ng-select [items]="statusOptions"
        bindLabel="label"
        bindValue="value"
        [(ngModel)]="filters.status"
        (ngModelChange)="onFiltersChange()"
        [clearable]="false"
        [searchable]="false"
        class="filter-select status-filter">
        <ng-template ng-label-tmp let-item="item">
          <span class="filter-label">
            <mat-icon>filter_list</mat-icon>
            {{ item.label }}
          </span>
        </ng-template>
      </ng-select>
    </div>

    @if (pendingCount > 0 && filters.status !== 'approved' && filters.status !== 'denied' && filters.status !== 'Cancel') {
      <div class="select-all-wrapper">
        <mat-checkbox class="bidone-checkbox" [(ngModel)]="selectAll" (ngModelChange)="toggleSelectAll()">
          Select All Pending
        </mat-checkbox>
      </div>
    }
  </div>

  <!-- Main Content - Split Panel -->
  <div class="main-content">
    <!-- Left Panel - Requests List -->
    <div class="left-panel">
      <div class="panel-header">
        <h3>Requests</h3>
        <span class="requests-count">{{ filteredRequests.length }} items</span>
      </div>

      <!-- Loading State -->
      @if (isLoading) {
        <div class="loading-state">
          <mat-spinner diameter="32"></mat-spinner>
          <span>Loading requests...</span>
        </div>
      }

      <!-- Empty State -->
      @if (!isLoading && filteredRequests.length === 0) {
        <div class="empty-state">
          <mat-icon>inbox</mat-icon>
          <p>No data available</p>
          <button class="btn-reset-filters" (click)="filters.searchTerm = ''; filters.type = 'all'; filters.status = 'all'; onFiltersChange()">
            Reset Filters
          </button>
        </div>
      }

      <!-- Grouped Requests List -->
      @if (!isLoading && groupedRequests.length > 0) {
        <div class="requests-list">
          @for (group of groupedRequests; track group) {
            <div class="staff-group">
              <!-- Group Header -->
              <div class="group-header" (click)="toggleGroup(group)">
                <div class="group-toggle">
                  <mat-icon>{{ group.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
                </div>
                <div class="staff-avatar">
                  {{ getInitials(group.staff_name) }}
                </div>
                <div class="staff-info">
                  <span class="staff-name">{{ group.staff_name }}</span>
                  <span class="staff-dept">{{ group.staff_department }}</span>
                </div>
                <div class="group-stats">
                  @if (group.pendingCount > 0) {
                    <span class="pending-count">
                      {{ group.pendingCount }} pending
                    </span>
                  }
                  <span class="total-count">{{ group.requests.length }} total</span>
                </div>
                @if (group.pendingCount > 0 && filters.status !== 'approved' && filters.status !== 'denied' && filters.status !== 'Cancel') {
                  <mat-checkbox class="bidone-checkbox"
                    [(ngModel)]="group.allSelected"
                    (ngModelChange)="toggleGroupSelectAll(group)"
                    (click)="$event.stopPropagation()">
                  </mat-checkbox>
                }
              </div>
              <!-- Group Requests -->
              @if (group.expanded) {
                <div class="group-requests">
                  @for (request of group.requests; track request) {
                    <div class="request-item"
                 [ngClass]="{
                   'selected': selectedRequest?.id === request.id,
                   'pending': request.status === 'pending',
                   'approved': request.status === 'approved',
                   'denied': request.status === 'denied',
                   'Cancel': request.status === 'Cancel'
                 }"
                      (click)="selectRequest(request)">
                      @if (request.status === 'pending') {
                        <mat-checkbox class="bidone-checkbox"
                          [checked]="request.selected"
                          (click)="toggleRequestSelection(request, $event)">
                        </mat-checkbox>
                      }
                      <div class="request-type-icon" [ngClass]="request.type.toLowerCase()">
                        <mat-icon>{{ getTypeIcon(request.type) }}</mat-icon>
                      </div>
                      <div class="request-info">
                        <div class="request-type-label">{{ request.type }}</div>
                        <div class="request-dates">{{ formatDateRange(request.start_date, request.end_date) }}</div>
                        <div class="request-days">{{ request.days }} day{{ request.days > 1 ? 's' : '' }}</div>
                      </div>
                      <div class="request-status" [ngClass]="request.status">
                        <mat-icon>{{ getStatusIcon(request.status) }}</mat-icon>
                        <span>{{ request.status | titlecase }}</span>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }

      <!-- Load More Button -->
      @if (!isLoading && groupedRequests.length > 0 && hasMoreRequests()) {
        <div class="load-more-section">
          <button class="btn-load-more"
            (click)="loadMoreRequests()"
            [disabled]="isLoadingMore">
            @if (isLoadingMore) {
              <mat-spinner diameter="20"></mat-spinner>
            }
            @if (!isLoadingMore) {
              <mat-icon>expand_more</mat-icon>
            }
            <span>{{ isLoadingMore ? 'Loading...' : 'Load More Requests' }}</span>
          </button>
          @if (pagination) {
            <div class="pagination-info">
              <span>Showing {{ pagination.from }} - {{ pagination.to }} of {{ pagination.total }}</span>
            </div>
          }
        </div>
      }
    </div>

    <!-- Right Panel - Request Details -->
    <div class="right-panel" [ngClass]="{'has-selection': selectedRequest}">
      @if (selectedRequest) {
        <div class="detail-header">
          <h3>Request Details</h3>
          <button class="btn-close-detail" (click)="selectedRequest = null">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="detail-content">
          <!-- Type Badge -->
          <div class="detail-type-badge" [ngClass]="selectedRequest.type.toLowerCase()">
            <mat-icon>{{ getTypeIcon(selectedRequest.type) }}</mat-icon>
            <span>{{ selectedRequest.type }}</span>
          </div>
          <!-- Staff Info -->
          <div class="detail-section">
            <div class="detail-label">Requested By</div>
            <div class="staff-detail">
              <div class="staff-avatar-lg">
                {{ getInitials(selectedRequest.staff_name) }}
              </div>
              <div class="staff-info-lg">
                <span class="name">{{ selectedRequest.staff_name }}</span>
                <span class="dept">{{ selectedRequest.staff_department }}</span>
              </div>
            </div>
          </div>
          <!-- Date Range -->
          <div class="detail-section">
            <div class="detail-label">Date Range</div>
            <div class="date-range-display">
              <div class="date-item">
                <mat-icon>event</mat-icon>
                <span>{{ formatDate(selectedRequest.start_date) }}</span>
              </div>
              <mat-icon class="date-arrow">arrow_forward</mat-icon>
              <div class="date-item">
                <mat-icon>event</mat-icon>
                <span>{{ formatDate(selectedRequest.end_date) }}</span>
              </div>
            </div>
          </div>
          <!-- Duration -->
          <div class="detail-section">
            <div class="detail-label">Duration</div>
            <div class="duration-display">
              <span class="days-value">{{ selectedRequest.days }}</span>
              <span class="days-label">business day{{ selectedRequest.days > 1 ? 's' : '' }}</span>
            </div>
          </div>
          <!-- Notes -->
          @if (selectedRequest.notes) {
            <div class="detail-section">
              <div class="detail-label">Notes</div>
              <div class="notes-display">
                <mat-icon>note</mat-icon>
                <p>{{ selectedRequest.notes }}</p>
              </div>
            </div>
          }
          <!-- Documents -->
          @if (selectedRequest.documents && selectedRequest.documents.length > 0) {
            <div class="detail-section">
              <div class="detail-label">Documents</div>
              <div class="documents-display">
                @for (doc of selectedRequest.documents; track doc.id) {
                  <div class="document-chip" (click)="openDocumentPreview(doc)" [attr.title]="doc.original_name">
                    <mat-icon>{{ getDocumentIcon(doc.file_type) }}</mat-icon>
                    <span>{{ doc.original_name }}</span>
                  </div>
                }
              </div>
            </div>
          }
          <!-- Submitted Date -->
          <div class="detail-section">
            <div class="detail-label">Submitted</div>
            <div class="submitted-display">
              <mat-icon>access_time</mat-icon>
              <span>{{ formatDate(selectedRequest.submitted_date) }}</span>
            </div>
          </div>
          <!-- Current Status -->
          <div class="detail-section">
            <div class="detail-label">Status</div>
            <div class="status-display" [ngClass]="selectedRequest.status">
              <mat-icon>{{ getStatusIcon(selectedRequest.status) }}</mat-icon>
              <span>{{ selectedRequest.status | titlecase }}</span>
            </div>
          </div>
          <!-- Action Buttons - CANCEL ONLY -->
          @if (selectedRequest.status === 'pending') {
            <div class="detail-actions">
              <button class="btn-cancel"
                (click)="cancelRequest(selectedRequest)"
                [disabled]="isProcessing || selectedRequest.isCancelling">
                @if (selectedRequest.isCancelling) {
                  <mat-spinner diameter="18"></mat-spinner>
                }
                @if (!selectedRequest.isCancelling) {
                  <mat-icon>block</mat-icon>
                }
                <span>{{ selectedRequest.isCancelling ? 'Cancelling...' : 'Cancel Request' }}</span>
              </button>
            </div>
          }
        </div>
      } @else {
        <div class="no-selection">
          <mat-icon>touch_app</mat-icon>
          <p>Select a request to view details</p>
        </div>
      }

    </div>
  </div>

  <!-- Bulk Actions Footer - BULK CANCEL ONLY -->
  @if (selectedCount > 0) {
    <div class="dialog-footer">
      <div class="selection-info">
        <mat-icon>check_box</mat-icon>
        <span>{{ selectedCount }} request{{ selectedCount > 1 ? 's' : '' }} selected</span>
      </div>
      <div class="bulk-actions">
        <button class="btn-bulk-cancel"
          (click)="bulkCancelRequests()"
          [disabled]="isProcessing">
          @if (isProcessing) {
            <mat-spinner diameter="18"></mat-spinner>
          }
          @if (!isProcessing) {
            <mat-icon>block</mat-icon>
          }
          <span>{{ isProcessing ? 'Processing...' : 'Bulk Cancel (' + selectedCount + ')' }}</span>
        </button>
      </div>
    </div>
  }
</div>
